define('Backbone.View.Plugin.DatePicker.FromToday', [
    'Backbone.View.render',

    'underscore',
    'jQuery',
    'bootstrap-datepicker'
],
function BackboneViewPluginDatePickerFromToday(
    BackboneView,

    _,
    jQuery
) {
    'use strict';

    return {
        mountToApp: function mountToApp() {
            if (!_.result(SC, 'isPageGenerator')) {
                BackboneView.postRender.install({
                    name: 'datePickerFromToday',
                    priority: 100,
                    execute: function execute($el, view) {
                        // if (_.isNativeDatePickerSupported() === false || _.isDesktopDevice()) {
                            view.$('input[type="date"][data-from-today]').each(function forEachDateFromToday() {
                                var $datePicker = jQuery(this);

                                try {
                                    $datePicker.attr('type', 'text');
                                } catch (ex) {
                                    /**
                                     * Attempting to change the type attribute (or property) of an input element
                                     * created via HTML or already in an HTML document will
                                     * result in an error being thrown by Internet Explorer 6, 7, or 8.
                                     * That's OK since IE wont understand type="date", but chrome and others should change it.
                                     */
                                }

                                $datePicker.datepicker({
                                    format: $datePicker.data('format'),
                                    beforeShowDay: function beforeShowDay(day) {
                                        var today = new Date();

                                        today.setHours(0);
                                        today.setMinutes(0);
                                        today.setSeconds(0);
                                        today.setMilliseconds(0);

                                        return day >= today;
                                    },
                                    startDate: $datePicker.data('start-date'),
                                    endDate: $datePicker.data('end-date'),
                                    autoclose: true,
                                    todayHighlight: $datePicker.data('todayhighlight')
                                });
                            });
                        //}
                    }
                });
            }
        }
    };
});

